import { combineReducers } from 'redux'

import session              from './session'
import flash                from './flash'

export default combineReducers({
  session
  flash
})
